import { Injectable } from '@angular/core';
import { EmployeeJobTitleModel } from './model/employee-job-title.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmployeeJobTitleService {

  constructor(private http: HttpClient) { }

  getList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/hr/employee-job-titles/list', requestData);
  }

  getById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/employee-job-title/get/' + id, '');
  }

  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(environment.baseUrl + '/employee-job-title/exportdatacsv', requestData, { headers, responseType: 'blob' });
  }

  update(info: EmployeeJobTitleModel): Observable<any> {
    if (info.hasOwnProperty("id") && info.id !== 0) {
      return this.http.post(environment.baseUrl + '/employee-job-title/update', info);
    } else {
      return this.http.post(environment.baseUrl + '/employee-job-title/add', info);
    }
  }

  delete(info: EmployeeJobTitleModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/employee-job-title/delete/' + info.id, info);
  }
}
